import styled from "styled-components";

export const Container = styled.div<{ $colorSelected: string | undefined }>`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.4rem;
	border-radius: 5px;
	background-color: white;
	border: 1px solid #e0e0e0;

	div img {
		margin-right: 14px;
		cursor: pointer;
	}

	div > span > div[title="${(props) => props.$colorSelected}"] {
		box-shadow:
			${(props) => props.$colorSelected} 0px 0px 0px 4px inset,
			${(props) => props.$colorSelected} 0px 0px 5px !important;
	}
`;

export const ColorPreview = styled.div<{ $color: string }>`
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background-color: ${(props) => props.$color};
	box-shadow:
		${(props) => props.$color} 0px 0px 0px 4px inset,
		${(props) => props.$color} 0px 0px 5px;
	margin-right: 14px;
	flex-shrink: 0;
	cursor: default;
`;
